import RichTextEditor from "../../components/RichTextEditor";
import { Button } from "../../components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/card";
import { MAX_TICKET_ATTACHMENTS } from "./constants";
export default function NewTicketView({ portal }) {
  const {
    tickets: {
      handleCreateTicket,
      handleTicketFilesChange,
      setTicketForm,
      ticketForm,
    },
    ui: { loading },
    session: { user },
    clients: { adminClients },
    developers: { activeDevelopers },
  } = portal;

  const isAdmin = user.role === "admin";
  const selectedClient = adminClients.find((client) => client.id === ticketForm.client_id);
  const assignableDevelopers = activeDevelopers.filter((developer) => developer.id === selectedClient?.managed_developer_id);

  return (
    <Card className="support-content-card">
      <CardHeader>
        <CardTitle className="heading-2">Nouvelle demande de modification</CardTitle>
      </CardHeader>
      <CardContent>
        <form onSubmit={handleCreateTicket} className="support-form-grid">
          {isAdmin && <>
            <label className="form-label">Client
              <select className="form-input" value={ticketForm.client_id} required onChange={(event) => setTicketForm({ ...ticketForm, client_id: event.target.value, developer_id: "" })}>
                <option value="">Sélectionner un client</option>
                {adminClients.map((client) => <option key={client.id} value={client.id}>{client.full_name} — {client.company_name}</option>)}
              </select>
            </label>
            <label className="form-label">Développeur affecté au client
              <select className="form-input" value={ticketForm.developer_id} disabled={!selectedClient} onChange={(event) => setTicketForm({ ...ticketForm, developer_id: event.target.value })}>
                <option value="">Sans attribution</option>
                {assignableDevelopers.map((developer) => <option key={developer.id} value={developer.id}>{developer.full_name}</option>)}
              </select>
              {selectedClient && assignableDevelopers.length === 0 && <span>Aucun développeur actif affecté à ce client.</span>}
            </label>
            <label className="form-label support-span-2">
              <input type="checkbox" checked={ticketForm.send_notifications} onChange={(event) => setTicketForm({ ...ticketForm, send_notifications: event.target.checked })} /> Envoyer les emails de notification au client, au développeur attribué et à l'administration
            </label>
          </>}
          <input className="form-input" type="text" placeholder="Titre de la demande" value={ticketForm.title} onChange={(e) => setTicketForm({ ...ticketForm, title: e.target.value })} required />
          <select className="form-input" value={ticketForm.category} onChange={(e) => setTicketForm({ ...ticketForm, category: e.target.value })}>
            <option value="modification-contenu">Modification de contenu</option>
            <option value="ajout-page">Ajout de page</option>
            <option value="correction-technique">Correction technique</option>
            <option value="seo">SEO</option>
          </select>
          <input className="form-input support-span-2" type="url" placeholder="URL du site concerne" value={ticketForm.site_url} onChange={(e) => setTicketForm({ ...ticketForm, site_url: e.target.value })} required />
          <div className="support-span-2">
            <RichTextEditor
              value={ticketForm.description}
              onChange={(value) => setTicketForm({ ...ticketForm, description: value })}
              placeholder="Expliquez precisement la modification souhaitee. Vous pouvez utiliser des listes et des blocs code."
              minHeight={220}
            />
          </div>
          <div className="support-span-2">
            <label className="form-label">Pieces jointes ({MAX_TICKET_ATTACHMENTS} max, PDF/JPG/PNG/DOCX)</label>
            <input className="form-input" type="file" multiple accept=".pdf,.png,.jpg,.jpeg,.docx" onChange={handleTicketFilesChange} />
            <p className="body-small">Vous pouvez ajouter jusqu'a {MAX_TICKET_ATTACHMENTS} fichiers, 5 Mo maximum par fichier.</p>
          </div>
          <Button type="submit" className="btn-primary support-span-2" disabled={loading}>
            {loading ? "Envoi..." : "Envoyer le ticket"}
          </Button>
        </form>
      </CardContent>
    </Card>
  );
}


